import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/constants';
import { UsersService } from 'src/app/service/users.service';
import { ActualService } from './../../service/actual.service';
import { HeaderService } from './header.service';
import { TldreturnsService } from 'src/app/service/tldreturns.service';
import { FGAData } from 'src/app/fga/models';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FormControl } from '@angular/forms';
import { VersionCheckService } from 'src/app/service/cache.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false // NOSONAR
})
export class HeaderComponent implements OnInit {
  constants: Constants = new Constants();
  navlinks = this.constants.navLinkItems;
  userName: any = '';
  getRole = { name: '', user_role: '', role_1: '', role_2: '' };
  rolesArray: string[] = [];
  userInfo: any;
  truckTypes: { trailerTypeId: number; truck: string; trailerType: string }[] =
    [];
  truckSelected: { trailerTypeId: number; truck: string; trailerType: string };
  guid;
  fgaDetails: FGAData | null = null;
  private subscription: Subscription;
  highlightHome = false;
  selected = new FormControl();
  currentIndex: any = 0;

  constructor(
    private  readonly actService: ActualService,
    private readonly userService: UsersService,
    private readonly headerService: HeaderService,
    private readonly state: TldreturnsService,
    private readonly versionCheckService: VersionCheckService
  ) {
    localStorage.getItem('toyotaGUID');
  }

  ngOnInit(): void {

    this.subscription = this.state.getDetails().subscribe(details => {
      this.fgaDetails = details;
      console.info('[Header] FGA details received:', details);
      if (this.fgaDetails) {
        this.userName = localStorage.getItem('name');
				const userName_ = this.fgaDetails?.user?.firstName + ' ' + this.fgaDetails?.user?.lastName;
        let roles: any = []
        this.rolesArray = [];
        roles = this.fgaDetails?.roles
        if (roles?.length) {
          roles.forEach(e => {
            this.rolesArray.push(e.displayName)
          })
        }
        this.getRole.name = userName_;
        this.getRole.user_role = 'Admin';

        localStorage.setItem('user-info', JSON.stringify(this.fgaDetails?.user));
        console.info('User Name: ' + this.userName);
        console.info('Role: ' + this.getRole.user_role);
        console.info('Guid: ' + this.guid);
        this.loadTrailerData();
      }

    });
    this.versionCheckService.initVersionCheck();
  }

  public loadTrailerData() {
    this.truckTypes = [];

    this.actService.getTrailerTypeData().subscribe((result) => {
      console.info(result);
      console.info('calling getTrailerTypeData');
      if (result?.length > 0) {
        localStorage.setItem('Truck-Types', JSON.stringify(result));
        this.truckTypes = result;
        this.truckSelected = this.truckTypes[0];
      } else {
        console.info('No response from getTrailerTypeData');
        localStorage.setItem(
          'Trailer-Types',
          JSON.stringify([
            { trailerTypeId: 1, truck: '53 FT DRY VAN', trailerType: '53-FT' },
          ])
        );
      }
    });
  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(this.constants.getLiosUrl());
  }

  ngOnDestroy(): void { // NOSONAR
		this.subscription.unsubscribe();
	}

	onTabClick(index: number) {
		localStorage.setItem('currentIndex', index.toString());
	}

	navigate(url: any) {
		const _url = environment.liosUrl + url;
		window.location.href = _url;
	}

	navigateExternalUrl(url: any) {
		window.location.href = url;
	}

	navigateExternalUrlNewWin(url: any) {
		window.open(url);
	}

	toggler(pageHeader: string): void {
		if ( pageHeader.includes('home') || pageHeader == '' || pageHeader == '#' ) { // NOSONAR
			this.highlightHome = true;
		} else {
			this.highlightHome = false;
		}
	}
}